// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"308":"quote","571":"settings","718":"design-project","810":"production-order"}[chunkId] || chunkId) + "." + {"308":"4ec2c8a1","341":"41ddd552","396":"59c462e0","571":"e31f915e","713":"6b14f080","718":"eda81821","810":"3d6f875f"}[chunkId] + ".js";
};